import { createTheme } from "@mui/material/styles";

export const displayFont = "'Marcellus', Georgia, serif";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#CFA75A", // dourado da marca
      light: "#E6C27A",
      dark: "#A8833E",
      contrastText: "#0B0B0B",
    },
    secondary: {
      main: "#0F0F0F", // preto elegante
      contrastText: "#FFFFFF",
    },
    background: {
      default: "#0B0B0B", // fundo principal do site
      paper: "#151515", // cards
    },
    text: {
      primary: "#F5F1E8",
      secondary: "rgba(245, 241, 232, 0.68)",
    },
    divider: "rgba(207, 167, 90, 0.18)",
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontFamily: "'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif",
    h1: { fontFamily: displayFont, fontWeight: 400, lineHeight: 1.05 },
    h2: { fontFamily: displayFont, fontWeight: 400, lineHeight: 1.15 },
    h3: { fontFamily: displayFont, fontWeight: 400, lineHeight: 1.2 },
    overline: { fontWeight: 600, letterSpacing: "0.28em", lineHeight: 1.6 },
    button: { textTransform: "none", fontWeight: 600, letterSpacing: "0.02em" },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { borderRadius: 999 } },
    },
  },
});

export default theme;
